import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS6 = props => {
    const ans = '人際關係'
    const select_arr = [
        {
            value: '1',
            label: '和氣'
        },
        {
            value: '2',
            label: '合群'
        },
        {
            value: '3',
            label: '活潑'
        },
        {
            value: '4',
            label: '信賴他人'
        },
        {
            value: '5',
            label: '好爭吵'
        },
        {
            value: '6',
            label: '自我中心'
        },
        {
            value: '7',
            label: '冷漠'
        },
        {
            value: '8',
            label: '不合群'
        }

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s6"
                   type="checkbox"/>
        </div>
    )
}

export default SseS6


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS6.jsx